import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getL2SheetProperty } from "../../../WorkbookSlice";
import { FaPlus, FaMinus, FaXmark } from "react-icons/fa6";

export default function NoformatModalDrop(props) {
  const {
    itemForNumFormat,
    Sheetid,
    closeModal,
    dispatchUpdateItem,
    reduxKey,
  } = props;
  console.log(itemForNumFormat);

  const ObjectArray =
    useSelector((state) => {
      return getL2SheetProperty(state, Sheetid, "query", reduxKey);
    }) || [];
  const { nanoId } = itemForNumFormat ?? {};

  const requiredObjectIndex = ObjectArray.findIndex(
    (item) => item.nanoId === nanoId
  );
  const requiredObject = ObjectArray[requiredObjectIndex];

  const [decimalPlaces, setDecimalPlaces] = useState();
  const [displayUnits, setDisplayUnits] = useState();
  console.log(decimalPlaces);
  console.log(displayUnits);

  const [prefix, setPrefix] = useState();
  const [sufix, setSufix] = useState();
  console.log(sufix);

  const [mode, setMode] = useState("Auto");
  // console.log(mode);

  useEffect(() => {
    if (requiredObject && requiredObject.numberObject) {
      console.log(requiredObject.numberObject);

      const {
        decimalPlaces: RdecimalPlaces,
        factor: RdisplayUnits,
        prefix: Rprefix,
        sufix: Rsuffix,
        mode: Rmode,
      } = requiredObject.numberObject;
      console.log(RdecimalPlaces);
      console.log(RdisplayUnits);

      // Set the initial values
      isNaN(RdecimalPlaces)
        ? setDecimalPlaces(1)
        : setDecimalPlaces(RdecimalPlaces);
      RdisplayUnits && setDisplayUnits(RdisplayUnits);
      Rprefix && setPrefix(Rprefix);
      setSufix(Rsuffix); // Use original sufix from numberObject
      Rmode && setMode(Rmode);
    }
  }, [requiredObject]);

  const decreaseDecimalPlaces = () => {
    if (decimalPlaces > 0) {
      setDecimalPlaces(decimalPlaces - 1);
    }
  };

  const increaseDecimalPlaces = () => {
    setDecimalPlaces(decimalPlaces + 1);
  };

  const handleChangeDisplayUnits = (event) => {
    setDisplayUnits(event.target.value);
  };

  const handleChangePrefix = (event) => {
    setPrefix(event.target.value);
  };

  useEffect(() => {
    if (requiredObject) {
      if (Number(displayUnits) !== requiredObject.numberObject.factor) {
        switch (Number(displayUnits)) {
          case 1:
            setSufix("");
            break;
          case 1000:
            setSufix("K");
            break;
          case 100000:
            setSufix("L");
            break;
          case 1000000:
            setSufix("M");
            break;
          case 10000000:
            setSufix("Cr");
            break;
          case 1000000000:
            setSufix("B");
            break;
          case 0.01:
            setSufix("%");
            setPrefix("");
            break;
          default:
            setSufix(""); // Default fallback if none match
            break;
        }
      } else {
        // If displayUnits is the same as the original factor, use the requiredObject's sufix
        setSufix(requiredObject.numberObject.sufix || "");
      }
    }
  }, [displayUnits, requiredObject]);

  const handleChangeSufix = (event) => {
    setSufix(event.target.value);
  };

  const handleSave = () => {
    const numberObject = {
      decimalPlaces: decimalPlaces === null ? 0 : decimalPlaces,
      factor: Number(displayUnits),
      prefix,
      sufix,
      mode,
    };
    console.log(numberObject);
    closeModal();

    dispatchUpdateItem({
      ...itemForNumFormat,
      index: requiredObjectIndex,
      numberObject,
    });
    console.log("modal closed");
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-50">
      <main
        className={`flex flex-col items-start justify-start w-80 bg-white rounded shadow-lg h-80`}
      >
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
          Format The Number
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <section className="w-full gap-4 flex items-start justify-start h-auto p-2">
          <div className="w-[20%] flex gap-2 items-center justify-center">
            <input
              type="radio"
              id="auto"
              name="mode"
              value="Auto"
              checked={mode === "Auto"}
              onChange={() => setMode("Auto")}
            />
            <label htmlFor="auto">Auto</label>
          </div>
          <div className="w-[30%] flex gap-2 items-center justify-center">
            <input
              type="radio"
              id="manual"
              name="mode"
              value="Manual"
              checked={mode === "Manual"}
              onChange={() => setMode("Manual")}
            />
            <label htmlFor="manual">Manual</label>
          </div>
        </section>
        <section
          className={` ${mode === "Auto" ? "opacity-50 pointer-events-none" : ""
            }`}
        >
          <section className="flex flex-col gap-6 w-full items-start justify-center h-[7rem] p-2">
            <div className="flex items-center justify-start gap-2 w-full py-2">
              <label htmlFor="decimalPlaces" className="">
                Decimal Places
              </label>
              <input
                id="decimalPlaces"
                className={`w-[60%] pl-1 border-gray-300 border-b ${mode === "Auto" ? "opacity-50" : ""
                  }`}
                value={decimalPlaces}
                readOnly
              />
              <button
                onClick={decreaseDecimalPlaces}
                className={`border p-[2px] rounded ${mode === "Auto" ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={mode === "Auto"}
              >
                <FaMinus className="font-[100]" />
              </button>
              <button
                onClick={increaseDecimalPlaces}
                className={`border p-[2px] rounded ${mode === "Auto" ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={mode === "Auto"}
              >
                <FaPlus className="font-[100]" />
              </button>
            </div>
            <div className="flex items-center justify-start gap-2 w-full">
              <label htmlFor="displayUnits" className="">
                Display Units
              </label>
              <select
                id="displayUnits"
                className={`w-[80%] py-2 px-4 border border-gray-300 rounded bg-white ${mode === "Auto" ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                value={displayUnits}
                onChange={handleChangeDisplayUnits}
                disabled={mode === "Auto"}
              >
                <option value="1">No Calculation</option>
                <option value="0.01">Percent %</option>
                <option value="1000">(Thousands = 1K)</option>
                <option value="100000">(Lacs = 1L)</option>
                <option value="1000000">(Millions = 1M)</option>
                <option value="10000000">(Crore = 1Cr)</option>
                <option value="1000000000">(Billions = 1B)</option>
              </select>
            </div>
          </section>
          <section
            className={`flex items-center justify-between w-full gap-4 h-[5rem] p-2`}
          >
            <div className={`flex items-center justify-start gap-2 w-[50%]`}>
              <label htmlFor="prefix" className="">
                Prefix
              </label>
              <select
                id="prefix"
                className={`w-[85%] py-2 px-4 border border-gray-300 rounded bg-white ${mode === "Auto" ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                value={prefix}
                onChange={handleChangePrefix}
                disabled={mode === "Auto"}
              >
                <option value="">No Prefix</option>
                <option value="₹">Rupees</option>
                <option value="$">Dollar</option>
              </select>
            </div>
            <div className={`flex items-center justify-start gap-2 w-[50%]`}>
              Suffix
              <input
                type="text"
                value={sufix}
                onChange={handleChangeSufix}
                className={`w-full py-[5px] px-4 border border-gray-300 rounded bg-white ${mode === "Auto" ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={mode === "Auto"}
              />
            </div>
          </section>
        </section>

        <section className="flex w-full items-center justify-end gap-4 p-2">
          <button onClick={closeModal} className="border w-20">
            Close
          </button>
          <button
            onClick={handleSave}
            className="border w-20 bg-blue-950 text-white"
          >
            Apply
          </button>
        </section>
      </main>
    </div>
  );
}
